// Import from Primer once available

const WrapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" aria-hidden="true">
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M1 13h3M1 3h14" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 7.25a.75.75 0 0 0 0 1.5h11.5a1.75 1.75 0 1 1 0 3.5H9.536v-.464a.679.679 0 0 0-1.086-.543l-1.619 1.214a.68.68 0 0 0 0 1.086l1.619 1.214a.679.679 0 0 0 1.086-.543v-.464H12.5a3.25 3.25 0 0 0 0-6.5z"
      clipRule="evenodd"
    />
  </svg>
)

export default WrapIcon

try{ WrapIcon.displayName ||= 'WrapIcon' } catch {}